module.exports = __webpack_public_path__ + "static/media/tm3.13b43a2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ipd503/tm3.jpg
// module id = 180
// module chunks = 0